import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
  Box,
  Card,
  makeStyles,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  Checkbox,
  withStyles,
  Fade
} from '@material-ui/core';
import { Pagination } from '@material-ui/lab';
import { PAGE_SIZE_LIST } from 'src/app/constant/config';
import LoadingComponent from 'src/app/components/Loading';

const StyledTableCell = withStyles(theme => ({
  head: {
    backgroundColor: theme.palette.common.white,
    color: theme.palette.common.black,
    whiteSpace: 'nowrap'
  },
  body: {
    fontSize: 14,
    whiteSpace: 'nowrap'
  },
  root: {
    padding: '6px'
  }
}))(TableCell);

const Results = ({
  className,
  totalCustomer,
  listCustomer,
  getListCustomerRef
}) => {
  const isLoading = useSelector(state => state.agencySlice.isLoading);
  const classes = useStyles();
  const [limit, setLimit] = useState(PAGE_SIZE_LIST);
  const [page, setPage] = useState(1);
  const [rowsSelected, setRowsSelected] = useState([]);

  const [params, setParams] = useState({
    page: page,
    page_size: limit
  });

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
    if (!getListCustomerRef) return;
    const newParams = Object.assign({}, params, { page: newPage });
    setParams(newParams);
    getListCustomerRef(newParams);
  };

  const checked = id => {
    return rowsSelected.indexOf(id) !== -1;
  };
  const select = driver => {
    if (rowsSelected.indexOf(driver) === -1) {
      const newSelected = [driver, ...rowsSelected];
      setRowsSelected(newSelected);
    } else {
      const newSelected = rowsSelected.filter(i => i !== driver);
      setRowsSelected(newSelected);
    }
  };

  const checkAll = () => {
    if (rowsSelected.length > 0) {
      setRowsSelected([]);
    }
    if (
      listCustomer.length > 0 &&
      rowsSelected.length !== listCustomer.length
    ) {
      const all = listCustomer.map(item => {
        return item.id;
      });
      setRowsSelected(all);
    }
  };

  return (
    <>   
      <Card className={clsx(classes.root, className)}>
        {isLoading ? (
          <LoadingComponent />
        ) : (
          <div>
            {rowsSelected.length > 0 && (
              <Fade in={rowsSelected.length > 0}>
                <Box
                  minWidth={1050}
                  style={{ fontSize: '14px', padding: '6px 4px' }}
                >
                  <span>
                    <Checkbox
                      checked={rowsSelected.length > 0}
                      onChange={() => checkAll()}
                      color="primary"
                      inputProps={{ 'aria-label': 'secondary checkbox' }}
                    />
                  </span>

                </Box>
              </Fade>
            )}
            <PerfectScrollbar>
              {listCustomer && listCustomer.length ? (
                <Box minWidth={1050}>
                  <Table>
                    {rowsSelected.length === 0 && listCustomer?.length > 0 && (
                      <TableHead>
                        <TableRow>
                          <StyledTableCell width={50}>
                            <Checkbox
                              checked={rowsSelected.length > 0}
                              onChange={() => checkAll()}
                              color="primary"
                              inputProps={{
                                'aria-label': 'secondary checkbox'
                              }}
                            />
                          </StyledTableCell>
                          <StyledTableCell width={250}>
                            Tên khách hàng
                          </StyledTableCell>
                          <StyledTableCell width={250}>
                            Số điện thoại
                          </StyledTableCell>
                          <StyledTableCell width={250}>Địa chỉ</StyledTableCell>
                          <StyledTableCell width={150}>
                            Thiết bị đã kích hoạt
                          </StyledTableCell>
                        </TableRow>
                      </TableHead>
                    )}
                    <TableBody>
                      {listCustomer.map((user) => (
                        <TableRow hover key={user.id}>
                          <StyledTableCell
                            style={{ maxWidth: '45px' }}
                            onClick={() => select(user?.id)}
                          >
                            <Checkbox
                              checked={checked(user.id)}
                              onChange={() => select(user.id)}
                              color="primary"
                              inputProps={{
                                'aria-label': 'secondary checkbox'
                              }}
                            />
                          </StyledTableCell>
                          <StyledTableCell>
                            {user?.username || '-'}
                          </StyledTableCell>
                          <StyledTableCell>
                            {user?.phone || '-'}
                          </StyledTableCell>
                          <StyledTableCell>
                            {user?.address || '-'}
                          </StyledTableCell>
                          <StyledTableCell>
                            {user?.deviceCount || '-'}
                          </StyledTableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </Box>
              ) : (
                <div className="text-center pb-5">
                  <img src="/static/empty.png" class="justify-content-center" />
                  <h4> Danh sách trống </h4>
                </div>
              )}
            </PerfectScrollbar>
          </div>
        )}
      </Card>
      {listCustomer && listCustomer.length > 0 && (
        <div class="mt-3 mr-4 float-right">
          <Box
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              gap: '15px'
            }}
          >
            <Typography style={{ fontSize: '14px' }}>
              Tổng: {totalCustomer}
            </Typography>
            <Pagination
              count={Math.ceil(totalCustomer / limit)}
              color='primary'
              size="small"
              onChange={handlePageChange}
              page={Number(params.page)}
              showFirstButton
              showLastButton
            />
          </Box>
        </div>
      )}
    </>
  );
};

Results.propTypes = {
  className: PropTypes.string,
  listAgencies: PropTypes.array.isRequired
};

const useStyles = makeStyles(theme => ({
  root: {
    //position: 'relative',
    marginTop: '20px'
  },
  groupAction: {
    display: 'flex',
    alignItems: 'center',
    '& .action': {
      cursor: 'pointer',
      padding: '0 5px',
      '&:hover': {
        color: '#3f51b5'
      }
    }
  },
  minWithColumn: {
    minWidth: '150px'
  }
}));

export default React.memo(Results);
